const getMinutesOfDay = (date: Date) =>
    date.getHours() * 60 + date.getMinutes();

export { getMinutesOfDay };
